// extracted by mini-css-extract-plugin
export default {"tableWrapper":"fIYiweRdelEHj6uwp7yY","table":"lv1v5zTFDfTogKhoBvVD","cancelled":"BVbsIxLQucYq2yC0oNGS"};